import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type PrimeTagSeverity =
    | 'success'
    | 'info'
    | 'warning'
    | 'warn'
    | 'danger'
    | 'primary'
    | 'secondary'
    | 'contrast';

@Component({
    selector: 'app-tag',
    templateUrl: './p-tag.component.html',
    styleUrls: ['./p-tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PTagComponent {
    /** Prime-style API */
    @Input() value?: string;
    @Input() severity?: PrimeTagSeverity;
    @Input() icon?: string;
    @Input() rounded?: boolean;
    @Input() styleClass?: string;
    @Input() style?: Record<string, any>;

    get computedClass(): string {
        const cls: string[] = ['p-tag', 'p-component'];
        const sev = this.normalizedSeverity;
        if (sev) cls.push(`p-tag-${sev}`);
        if (this.rounded) cls.push('p-tag-rounded');
        if (this.styleClass) cls.push(...this.styleClass.split(' ').filter(Boolean));
        return cls.join(' ');
    }

    get normalizedSeverity(): string | null {
        if (!this.severity) return null;
        // Prime accepts warn and warning; class is p-tag-warning
        if (this.severity === 'warn') return 'warning';
        return this.severity;
    }

    get hasProjectedContent(): boolean {
        return this.value == null || String(this.value).length === 0;
    }
}

